export class StimulusLoader {
  constructor({controllers: controllers}){
    this.controllers = controllers;
  }

  registerControllers() {
    Object.entries(this.controllers).forEach(([path, module]) => {
      const name = path.split("/").pop().replace("_controller.js", "").replaceAll("_", "-");
      window.application.register(name, module.default);
    })
  }
}
